import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import { ReactComponent as ArrowExpand } from '../../../assets/img/icons/common/ArrowExpand.svg';
import useKitchenPlayerContext from '../../../containers/KitchenPlayer/hooks/useKitchenPlayerContext';
import EventImage from '../../HistoryPlayer/components/Event/EventImage';
import EventName from '../../HistoryPlayer/components/Event/EventName';
import './EventItem.scss';

export const EventItem = ({ rootRef, event, setSelectedEvent, historyMode, active, loadImage = true }) => {
  const { setEventDetails } = useKitchenPlayerContext();

  const onClick = () => {
    if (active) {
      setSelectedEvent(null);
    } else {
      setSelectedEvent(event);
      
      if (historyMode) {
        document.dispatchEvent(
          new CustomEvent('jumpToEvent', {
            detail: event,
          })
        );
      }
    }
  };

  return (
    <div
      key={event.uuid}
      ref={rootRef}
      className={cx('activity-history-item', {
        'activity-history-item-active': Boolean(active),
      })}
      onClick={onClick}
    >
      <div className="event__time-point">
        {event.displayTime && <span className="time">{moment(event.eventTime).format('h A')}</span>}
        <div className="point"></div>
      </div>

      <div className="event__content">
        <div className="event__image-container">
          <button
            className="event__image-expand-btn"
            onClick={mouseEvent => {
              mouseEvent.stopPropagation();
              setEventDetails(event);
            }}
          >
            <ArrowExpand />
          </button>

          <EventImage url={loadImage ? event.frame : null} initialLoading={Boolean(event.frame)} />
        </div>

        <div className="event__details">
          <EventName eventName={event.eventName} />
          <div className="event__description">{event.description}</div>

          <div className="event__details-footer">
            {event.location ? (
              <span
                className="event__info event__location"
                data-toggle="tooltip"
                data-placement="bottom"
                title={event.location}
              >
                {event.location}
              </span>
            ) : null}

            <span className="event__info event__time">{moment(event.eventTime).format('h:mm:ss A')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
